import React, { useEffect } from 'react';
import homeImg from '../assets/home_img.png';
import aboutImg from '../assets/about_img.jpg';
import roadImg from '../assets/road.jpg';

const BackgroundPreloader = () => {
  useEffect(() => {
    // Preload all background images to prevent flash
    const imagesToPreload = [homeImg, aboutImg, roadImg];

    imagesToPreload.forEach(src => {
      const img = new Image();
      img.src = src;
      // Store in memory to prevent reload
      img.style.display = 'none';
      document.body.appendChild(img);
    });

    // Also preload the gradient background by applying it to a hidden element
    const gradientPreloader = document.createElement('div');
    gradientPreloader.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%);
      z-index: -9999;
      opacity: 0;
      pointer-events: none;
    `;
    document.body.appendChild(gradientPreloader);

    // Force the background image to be loaded and cached
    const homeImage = new Image();
    homeImage.src = homeImg;
    homeImage.onload = () => {
      // Once loaded, ensure it's visible immediately
      const homeElements = document.querySelectorAll('.HomeImg');
      homeElements.forEach(el => {
        el.style.backgroundImage = `url(${homeImg})`;
        el.style.backgroundColor = 'transparent';
      });
    };

    return () => {
      // Cleanup on unmount
      document.body.removeChild(gradientPreloader);
    };
  }, []);

  return null; // This component doesn't render anything
};

export default BackgroundPreloader;
